import React from "react";
import "../styles/Section1.scss";

const Section1 = () => {
  return (
    <section className="section-hero" id="sectionStart">
      {/* Video de fondo */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video"
      >
        <source src="https://ovitsolucionesweb.com/ovit.mp4" type="video/mp4" />
        Tu navegador no soporta el video.
      </video>

      {/* Capa oscura */}
      <div className="hero-overlay"></div>

      {/* Contenido */}
      <div className="hero-content">
        <h2>
          Construye tu libertad<br/><span className="highlight1">con una carrera en seguros.</span>
        </h2>
        <p>
          Forma parte de Asesorarte en Seguros y descubre cómo generar abundancia ayudando a familias a proteger su futuro. Crece personal y financieramente con nuestro acompañamiento.
        </p>
        <a href="#inicio" className="hero-button">
          Comienza tu carrera hoy
        </a>
      </div>
    </section>
  );
};

export default Section1;
